import React, { createContext, useContext, useMemo } from 'react';
import { combatantLabel } from '../../../shared/combatantNames.mjs';
const Names = createContext((id, fallback) => fallback);
export function CombatantNamesProvider({ enemies = [], dm = false, children }) {
  const resolve = useMemo(() => {
    const lookup = new Map(enemies.map(enemy => [String(enemy.enemyId || enemy._id), enemy]));
    return (id, fallback) => combatantLabel(lookup.get(String(id)), { dm, fallback });
  }, [enemies, dm]);
  return <Names.Provider value={resolve}>{children}</Names.Provider>;
}
export const useCombatantName = () => useContext(Names);
